var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "task-obj-value text-icon" },
    [
      !_vm.isEdit
        ? [
            _c("SelectSearch", {
              ref: "search",
              staticClass: "mr-1",
              attrs: {
                name: "task-obj-value",
                placeholder:
                  _vm.inputText.length > 0
                    ? _vm.inputText
                    : "Введите название объекта",
                labelCallback: (item) =>
                  item.id ? item.name : "Введите название объекта",
                empty: "",
                items: _vm.items,
                searchText: _vm.inputText,
                active: [_vm.activeId],
                "un-focus-clear-value": false,
              },
              on: {
                blur: _vm.createObject,
                changeSearchText: (val) => (_vm.inputText = val.trim()),
                selectChange: _vm.selectItem,
              },
            }),
            _vm._v(" "),
            _vm.activeId && !(_vm.$refs.search || {}).isShowInput
              ? [
                  _c(
                    "TipMessage",
                    { attrs: { text: "Изменить выбранный объект" } },
                    [
                      _c("Icon", {
                        attrs: { id: "edit", size: "18", color: "green" },
                        on: { click: _vm.startEditObject },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TipMessage",
                    { attrs: { text: "Удалить выбранный объект" } },
                    [
                      _c("Icon", {
                        attrs: { id: "delete", size: "18", color: "purple" },
                        on: { click: _vm.deleteRequest },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm.activeId
        ? [
            _c(
              "div",
              { staticClass: "placeholder placeholder_input placeholder_icon" },
              [
                _c("input", {
                  directives: [
                    { name: "focus", rawName: "v-focus" },
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.inputText,
                      expression: "inputText",
                      modifiers: { trim: true },
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.inputText },
                  on: {
                    blur: [
                      _vm.finishEditObject,
                      function ($event) {
                        return _vm.$forceUpdate()
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.inputText = $event.target.value.trim()
                    },
                  },
                }),
                _vm._v(" "),
                _c("Icon", { attrs: { id: "edit" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("Icon", {
              attrs: { id: "delete", size: "18", color: "purple" },
              on: { click: _vm.stopEditObject },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }